import * as React from "react"
import { useState } from "preact/hooks"
import { Modal,Box } from "@material-ui/core";

export const DisplayOnce = ({ id, children, ...rest}) => {
	const [isDisplayed, setIsDisplayed] = useLocalStorage(`displayOnce-${id}`)
	if (!isDisplayed) {
		return <ModalWrapper {...rest} key={`${id}-modal`} dismiss={() => setIsDisplayed(true)}>{children}</ModalWrapper>
	} else {
		return null
	}
}

export const DisplayAlways = ({ id, children, ...rest}) => {
	const [isDisplayed, setIsDisplayed] = useState(false)
	if (!isDisplayed) {
		return <ModalWrapper {...rest} key={`${id}-modal`} dismiss={() => setIsDisplayed(true)}>{children}</ModalWrapper>
	} else {
		return null
	}
}

export const VimeoFrame = ({ vidId, wrapperStyle = {} }) => {
	return <div class="tk-vimeo-frame" style={{ padding: "30px 30px 24px 30px", borderRadius: "12px", backgroundColor: "#3c1d4a", position: "relative", ...wrapperStyle }}>
		<iframe src={`https://player.vimeo.com/video/${vidId}`} width="900" height="530" frameborder="0" allow="autoplay; fullscreen" allowfullscreen />
	</div>
}

export const SmallVimeoFrame = ({ vidId }) => 
{
	return <div class="tk-vimeo-frame" style={"padding: 30px 30px 24px 30px;; border-radius: 12px; background-color: #3c1d4a; position: relative"}>
		<iframe src={`https://player.vimeo.com/video/${vidId}`} width="350" height="270" frameborder="0" allow="autoplay; fullscreen" allowfullscreen />
	</div>
}

export const YouTube = ({ vidId }) => 
{
	return <div class="tk-youtube-frame" style="padding: 30px 30px 24px 30px;; border-radius: 12px; background-color: #3c1d4a; position: relative">
  		<iframe src={`https://www.youtube.com/embed/${vidId}`} width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen/>
	</div>
}

export const ModalLink = function({
	href = null,
	target = null,
	onClick = () => null,
	width,
	height,
	left,
	top,
	label,
    position = "absolute",
	modal = null,
	roomName = "",
	CometChatID = null,
	CometChatUserID = null,
	isExternal = undefined,
	gameRule = null,
	gameRuleCooldown = 0,
	gaAction = "Link Click",
	hoverMessage = null
}) {
    const optionals = {}
    const [modalVisible, setOpen] = useState(false);
    const toggleModal = () => setOpen(!modalVisible);

	const isRedirectTrackingLink = !isExternal && href?.length && !href.startsWith("http") && !href.startsWith("/")
	let generatedOnClick = () => { }

	if (modal) {
		// eslint-disable-next-line no-param-reassign
		generatedOnClick = () => {
			toggleModal()
		}
	} else if (CometChatID) {
		// eslint-disable-next-line no-param-reassign
		generatedOnClick = () => {
			window.CometChatWidget.openOrCloseChat(true)
			window.CometChatWidget.chatWithGroup(CometChatID)
		}
	} else if (CometChatUserID) {
		// eslint-disable-next-line no-param-reassign
		generatedOnClick = () => {
			window.CometChatWidget.openOrCloseChat(true)
			window.CometChatWidget.chatWithUser(CometChatUserID)
		}
	} else if (isRedirectTrackingLink) {
		// eslint-disable-next-line no-param-reassign
		generatedOnClick = () => {
			window.redirectTracking(href, 1)
		}
	}

	if (!isRedirectTrackingLink && href) { optionals.href = href }

	const className = roomName ? "_gtm-event" : ""

	return <>
            <a
                key={`${label}-${roomName}`}
                target={target}
                onClick={() => {
                    if (onClick) { onClick(); generatedOnClick() }
                    if (gameRule) { triggerGamificationRule(gameRule, gameRuleCooldown) }
                }}
                data-text={hoverMessage}
                id={label}
                data-event-category={roomName}
                data-event-action={gaAction}
                data-event-label={label}
                title={label}
                aria-label={label}
                class={className}
                style={{
                    width,
                    height,
                    left,
                    top,
                    position,
                    cursor: "pointer",
                    textDecoration: "none"
                }}
                {...optionals}
            >
            </a>
			<ModalWrapper onClose={toggleModal} open={modalVisible && modal}>
				{modal || null}
			</ModalWrapper>
        </>
}

export const ModalWrapper = ({ children, dismiss, onClose, style = {} }) => {
    const [modalVisible, setOpen] = useState(true);
	return (
		<Modal className="modal-wrapper" open={modalVisible} onClose={onClose} >
			<Box sx={{
					height: 'fit-content',
					width: 'fit-content',
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					bgcolor: '#ad15ab',
					border: '2px solid #000',
					borderRadius: '12px',
					...style
				}}>
					<span style={{
						position: 'absolute',
						top: '0',
						right: '5',
						cursor: 'pointer',
						zIndex: '1',
						padding: '5px',
						fontSize: '20px',
						fontWeight: 'bold',
						color: '#000',
					}}
					onClick={
						(e) => {
							dismiss// Carry over from previous implementation
							setOpen(false)
						}
					}
					>X</span>
			{children}
			</Box>
		</Modal>
	)
}